export { default as DetailedStudentListPage } from "./DetailedStudentList";
export { default as LoginPage } from "./Login";
export { default as MainPage } from "./Main";
